<script setup lang="ts">
import type { TransitionProps } from "vue";
import { tw } from "../../lib/utils";

const props = defineProps<Pick<TransitionProps, "mode">>();
</script>

<template>
	<Transition
		:mode="props.mode"
		:enterActiveClass="tw`transition duration-200 ease-out`"
		:enterFromClass="tw`transform opacity-0`"
		:enterToClass="tw`transform opacity-100`"
		:leaveActiveClass="tw`transition duration-100 ease-out`"
		:leaveFromClass="tw`transform opacity-100`"
		:leaveToClass="tw`transform opacity-0`"
	>
		<slot />
	</Transition>
</template>
